export enum FETCH_NOTE_PER_ENTITY {
    REQUEST = 'FETCH_NOTE_PER_ENTITY_REQUEST',
    SUCCESS = 'FETCH_NOTE_PER_ENTITY_SUCCESS',
    FAILURE = 'FETCH_NOTE_PER_ENTITY_FAILURE'
}

export enum CREATE_NOTE {
    REQUEST = 'CREATE_NOTE_REQUEST',
    SUCCESS = 'CREATE_NOTE_SUCCESS',
    FAILURE = 'CREATE_NOTE_FAILURE'
}

export enum SAVE_NOTE {
    REQUEST = 'SAVE_NOTE_REQUEST',
    SUCCESS = 'SAVE_NOTE_SUCCESS',
    FAILURE = 'SAVE_NOTE_FAILURE'
}

export enum DELETE_NOTE {
    REQUEST = 'DELETE_NOTE_REQUEST',
    SUCCESS = 'DELETE_NOTE_SUCCESS',
    FAILURE = 'DELETE_NOTE_FAILURE'
}